import { DROPDOWN_FIRST_INDEX } from '../../constant/product-option';
import { useProductOptionContext } from '../../context/ProductOptionProvider';
import { PdpDeliveryType, ProductOptionConfig, SelectBoxDropdownItem } from '../../type/common.type';

interface Props {
  option_dropdown_list: SelectBoxDropdownItem[][];
  config: ProductOptionConfig;
}

export const useShippingFilter = ({ option_dropdown_list, config }: Props) => {
  const { state, actions } = useProductOptionContext();

  // 배송 필터 토글
  const handleClickShippingFilterToggle = () => {
    let should_reset_selection = false;
    const toggle_to_zigzin_only = !state.ui.is_only_zigzin_option_active;

    if (toggle_to_zigzin_only) {
      // 현재 선택된 그룹과 드롭다운의 옵션 데이터 가져오기
      const current_group = option_dropdown_list[state.selection.selected_group_index];
      const current_dropdown = current_group?.[state.selection.selected_dropdown_index];
      const current_option = current_dropdown?.data ?? [];

      const is_first_dropdown = state.selection.selected_dropdown_index === DROPDOWN_FIRST_INDEX;
      const has_available_zigzin_option = current_option.some(
        (item) =>
          item.option.shipping?.type === PdpDeliveryType.ZIGZIN ||
          item.option.shipping?.type === PdpDeliveryType.VENDOR_FLEX,
      );
      // 첫번째 드롭다운이 아니고, 직진 옵션이 없는 경우 초기화
      should_reset_selection = !is_first_dropdown && !has_available_zigzin_option;
    }

    actions.toggleShippingFilter({ should_reset_selection });
  };

  return {
    display:
      !config.hidden_flags?.shipping_filter_button &&
      !state.ui.is_restock_selection_mode &&
      !state.ui.is_item_card_mode_active &&
      state.ui.display_shipping_filter_button,
    checked: state.ui.is_only_zigzin_option_active,
    color_type: state.ui.shipping_filter_color_type,
    actions: {
      handleClickShippingFilterToggle,
    },
  };
};
